export const phoneNumber = (phone) => {
    const cleaned = `${phone}`.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return null;
  };

  export const mapContainerStyle = {
    width: '100%',
    height: '400px'
  };
  
  // Desktop animation variants for backdrop
  export const backdropVariants = {
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
  };
  
  // animation variants for details-modal
  export const modalVariants = {
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 1,
        type: 'spring',
      },
    },
    hidden: {
      opacity: 0,
      scale: 0,
      transition: {
        duration: 1,
        type: 'spring',
      },
    },
  };
  
  // animation variants for sidebar
  export const sidebarVariants = {
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
      },
    },
    hidden: {
      opacity: 0,
      x: '100%',
      transition: {
        duration: 0.5,
        type: 'spring',
      },
    },
  };
  
  // animation variants for product list
  export const containerVariants = {
    open: {
      transition: { staggerChildren: 0.07, delayChildren: 0.2, delay: 1 },
    },
    closed: {
      transition: { staggerChildren: 0.05, staggerDirection: -1, delay: 1 },
    },
  };

  export const frequencies = [
    { id: 0, name: 'daily' },
    { id: 1, name: 'weekly' },
    { id: 2, name: 'monthly' },
    { id: 3, name: 'yearly' },
    { id: 4, name: 'on-demand' },
  ]

  export const fileColumnDataType = [
    { id: 0, name: 'text' },
    { id: 1, name: 'datetime' },
    { id: 2, name: 'date' },
    { id: 3, name: 'time' },
    { id: 4, name: 'number' },
    { id: 5, name: 'currency' },
  ]

  export const uploadHistoryFilters = [
    { id: 0, name: 'all' },
    { id: 1, name: 'pending' },
    { id: 2, name: 'processing' },
    { id: 3, name: 'processed' },
    { id: 4, name: 'failed' },
  ]
  
  export const storageFileProcessesFilters = [
    { id: 0, name: 'all' },
    { id: 1, name: 'pending' },
    { id: 2, name: 'processing' },
    { id: 3, name: 'processed' },
    { id: 4, name: 'failed' },
  ]

  export const storageFileProcessesStatus = [
    { id: 0, name: 'pending' },
    { id: 1, name: 'processing' },
    { id: 2, name: 'processed' },
    { id: 3, name: 'failed' },
  ]

  export const ageGroups = [
    { id: 0, name: 'LessThanThirty' },
    { id: 1, name: '30 - 40' },
    { id: 2, name: '41 - 50' },
    { id: 3, name: '51 - 60' },
    { id: 4, name: 'MoreThanSixty' }
  ]

  export const salaryGroups = [
    { id: 0, name: '$0 - $75k' },
    { id: 1, name: '$76 - $150k' },
    { id: 2, name: 'MoreThanOneHundredFiftyK' }
  ]

  export const averageMonthlyPaymentGroups = [
    { id: 0, name: 'LessThanHundred' },
    { id: 1, name: '$100 - $200' },
    { id: 2, name: '$201 - $300' },
    { id: 3, name: '$301 - $400' },
    { id: 4, name: 'MoreThanFourHundred' }
  ]

  export const creditScoreGroups = [
    { id: 0, name: 'LessThanSixHoundredSeventy' },
    { id: 1, name: '670 - 739' },
    { id: 2, name: '740 - 799' },
    { id: 3, name: '800 - 850' },
    { id: 4, name: 'idk' }
  ]

  export const roofTypes = [
    { id: 0, name: 'TypeA' },
    { id: 1, name: 'TypeB' },
    { id: 2, name: 'Unknown' },
  ]

  export const batteryBrands = [
    'Solar Edge',
    'Tesla'
  ];

  export const prMunicipalities = [
    'Adjuntas',
'Aguada',
'Aguadilla',
'Aguas Buenas',
'Aibonito',
'Añasco',
'Arecibo',
'Arroyo',
'Barceloneta',
'Barranquitas',
'Bayamón',
'Cabo Rojo',
'Caguas',
'Camuy',
'Canóvanas',
'Carolina',
'Cataño',
'Cayey',
'Ceiba',
'Ciales',
'Cidra',
'Coamo',
'Comerío',
'Corozal',
'Culebra',
'Dorado',
'Fajardo',
'Florida',
'Guánica',
'Guayama',
'Guayanilla',
'Guaynabo',
'Gurabo',
'Hatillo',
'Hormigueros',
'Humacao',
'Isabela',
'Jayuya',
'Juana Díaz',
'Juncos',
'Lajas',
'Lares',
'Las Marías',
'Las Piedras',
'Loíza',
'Luquillo',
'Manatí',
'Maricao',
'Maunabo',
'Mayagüez',
'Moca',
'Morovis',
'Naguabo',
'Naranjito',
'Orocovis',
'Patillas',
'Peñuelas',
'Ponce',
'Quebradillas',
'Rincón',
'Río Grande',
'Sabana Grande',
'Salinas',
'San Germán',
'San Juan',
'San Lorenzo',
'San Sebastián',
'Santa Isabel',
'Toa Alta',
'Toa Baja',
'Trujillo Alto',
'Utuado',
'Vega Alta',
'Vega Baja',
'Vieques',
'Villalba',
'Yabucoa',
'Yauco'
  ]
